import ApiService from "@/common/api.service";
import { FETCH_BALANCEBANKS, FETCH_RESUMEN } from "../actions.type";
import { SET_BALANCEBANKS, SET_RESUMEN } from "../mutations.type";

const state = {
  balanceBanks: [],
  resumen: []
};

const getters = {
  balanceBanks(state) {
    return state.balanceBanks;
  },

  resumen(state) {
    return state.resumen;
  }
};

const mutations = {
  [SET_BALANCEBANKS](state, balanceBanks) {
    state.balanceBanks = balanceBanks;
  },

  [SET_RESUMEN](state, resumen) {
    state.resumen = resumen;
  }
};

const actions = {
  [FETCH_BALANCEBANKS](context, filters) {
    return ApiService.post("reports/balanceBanks", filters).then(
      balanceBanks => {
        context.commit(SET_BALANCEBANKS, balanceBanks);
        return Promise.resolve(balanceBanks);
      }
    );
  },

  [FETCH_RESUMEN](context, filters) {
    return ApiService.post("reports/resumen", filters).then(resumen => {
      context.commit(SET_RESUMEN, resumen);
      return Promise.resolve(resumen);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
